import React, { useEffect, useState, Fragment } from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
export function UrgencySection() {
  const [timeLeft, setTimeLeft] = useState(8 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const digits = [{
    value: h.toString().padStart(2, '0'),
    label: 'Horas'
  }, {
    value: m.toString().padStart(2, '0'),
    label: 'Min'
  }, {
    value: s.toString().padStart(2, '0'),
    label: 'Seg'
  }];
  const losses = ['El 50% de descuento desaparece', 'Los 6 bonos gratis ya no están', 'El precio vuelve a $39.998', 'Otra mañana caótica sin sistema'];
  return <section className="py-14 bg-burgundy relative overflow-hidden" data-id="element-412">
      {/* Sparkle decorations */}
      <div className="absolute top-6 left-6 opacity-30" data-id="element-413">
        <SparkleDecoration size={20} color="#F2A59D" type="star" data-id="element-414" />
      </div>
      <div className="absolute bottom-8 right-8 opacity-30" data-id="element-415">
        <SparkleDecoration size={24} color="#E8735A" data-id="element-416" />
      </div>

      <div className="max-w-sm mx-auto px-4 text-center" data-id="element-417">
        <AnimatedSection data-id="element-418">
          <h2 className="text-xl md:text-2xl font-serif font-bold text-cream mb-6" data-id="element-419">
            ⏰ Esta oferta desaparece hoy
          </h2>

          {/* Countdown digits */}
          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-420">
            {digits.map((d, i) => <Fragment key={i} data-id="element-421">
                <div className="flex flex-col items-center" data-id="element-422">
                  <div className="bg-cream/10 border border-cream/15 rounded-xl px-4 py-2.5 min-w-[56px]" data-id="element-423">
                    <span className="text-3xl font-black text-coral font-mono tracking-wider" style={{
                  fontVariantNumeric: 'tabular-nums'
                }} data-id="element-424">
                      {d.value}
                    </span>
                  </div>
                  <span className="text-cream/50 text-[9px] uppercase tracking-widest font-bold mt-1.5" data-id="element-425">
                    {d.label}
                  </span>
                </div>
                {i < digits.length - 1 && <span className="text-coral font-bold text-xl mb-4" data-id="element-426">:</span>}
              </Fragment>)}
          </div>

          {/* Losses list */}
          <div className="bg-black/15 rounded-xl p-4 mb-6 text-left" data-id="element-427">
            <p className="text-cream font-bold text-xs mb-3 text-center uppercase tracking-wider" data-id="element-428">
              Si esperás a mañana perdés:
            </p>
            <ul className="space-y-2" data-id="element-429">
              {losses.map((loss, index) => <li key={index} className="flex items-start gap-2 text-cream/80 text-xs" data-id="element-430">
                  <span className="text-coral flex-shrink-0 mt-px" data-id="element-431">❌</span>
                  <span data-id="element-432">{loss}</span>
                </li>)}
            </ul>
          </div>

          {/* CTA */}
          <a href="#precio" className="inline-block bg-emerald-500 text-white px-6 py-3 rounded-full font-bold text-sm hover:scale-105 transition-transform duration-300 shadow-lg" data-id="element-433">
            QUIERO MI PACK AHORA →
          </a>
        </AnimatedSection>
      </div>
    </section>;
}